/**
 *
 * Asynchronously loads the component for StudyCertificate
 *
 */

import { lazyLoad } from 'controller/utils/loadable';

export const StudyCertificate = lazyLoad(
    () => import('./index'),
    module => module.StudyCertificate,
);
